import { render, staticRenderFns } from "./search-btns.vue?vue&type=template&id=9611746a&scoped=true"
import script from "./search-btns.vue?vue&type=script&lang=js"
export * from "./search-btns.vue?vue&type=script&lang=js"
import style0 from "./search-btns.vue?vue&type=style&index=0&id=9611746a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9611746a",
  null
  
)

export default component.exports